
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { ArgsTable, Canvas, Meta, Story } from '@storybook/addon-docs';
// The '!!raw-loader!' syntax is a non-standard, Webpack-specific, syntax.
// See: https://github.com/webpack-contrib/raw-loader#examples
// For now, it seems likely Storybook is pretty tied to Webpack, therefore, we are
// okay with the following Webpack-specific raw loader syntax. It's better to leave
// the ESLint rule enabled globally, and only thoughtfully disable as needed (e.g.
// within a Storybook docs page and not within an actual component).
// This can be revisited in the future if Storybook no longer relies on Webpack.
// eslint-disable-next-line @cloudfour/import/no-webpack-loader-syntax
import inputGroupDemoSource from '!!raw-loader!./demo/input-group-demo.twig';
import inputGroupDemo from './demo/input-group-demo.twig';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Objects/Input Group" argTypes={{
      class: {
        type: 'string',
        description: 'Appends to the CSS class of the root element',
        table: {
          defaultValue: {
            summary: ''
          }
        }
      }
    }} mdxType="Meta" />
    <h1>{`Input Group`}</h1>
    <p>{`The Input Group object accepts controls like `}<a parentName="p" {...{
        "href": "/story/components-button--button-element"
      }}>{`Button`}</a>{` and `}<a parentName="p" {...{
        "href": "/story/components-input--text-elements"
      }}>{`Input`}</a>{`, displaying them adjacent to one another with no whitespace between. This is useful for presenting minimal forms, such as search bars.`}</p>
    <p>{`Buttons and inputs can be put in whatever order you choose.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Example" parameters={{
        docs: {
          source: {
            code: inputGroupDemoSource
          }
        }
      }} mdxType="Story">
    {args => inputGroupDemo(args)}
  </Story>
    </Canvas>
    <h2>{`Template Properties`}</h2>
    <ArgsTable story="Example" mdxType="ArgsTable" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;

export const example = (args => inputGroupDemo(args));
example.storyName = 'Example';
example.parameters = { storySource: { source: 'args => inputGroupDemo(args)' }, ...{
  docs: {
    source: {
      code: inputGroupDemoSource
    }
  }
} };

const componentMeta = { title: 'Objects/Input Group', argTypes: {
  class: {
    type: 'string',
    description: 'Appends to the CSS class of the root element',
    table: {
      defaultValue: {
        summary: ''
      }
    }
  }
}, includeStories: ["example"],  };

const mdxStoryNameToKey = {"Example":"example"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;